import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  user_company_details,
  user_institutions_detail,
  user_resource_detail,
  user_expert_detail,
  user_get_pplication,
  user_get_candidate_details,
  user_get_vendor_detail,
  user_dash_list,
} from "../../../user.api";
import ReactHtmlParser from "react-html-parser";
import CustomTable from "../../../../../components/table/table";
import moment from "moment";
import Swal from "sweetalert2";
import CustomIcons from "../../../../../components/icons/kIcons.component";
import {
  add_financial_record,
  update_financial_record,
  upload_application_logo,
  upload_company_logo,
} from "../../../user.api";

const DashProfileDetails = (props) => {
  const history = useHistory();
  const [data, setData] = useState({});
  const [userId, setUserId] = useState(props?.data?.user_id);
  const [id, setId] = useState(props?.data?.id);
  const [userRole, setUserRole] = useState(props?.userType);
  const [loading, setLoading] = useState(true);

  // Debug logging
  console.log("DashProfileDetails Props:", {
    userType: props?.userType,
    companyData: props?.companyData,
    data: props?.data,
    userData: props?.userData
  });

  const loadData = async (isMounted = true) => {
    try {
      // For company users, branch logic based on parent company type
      if (props?.companyData?.is_company_user) {
        let res;
        if (props?.companyData?.parent_company?.company_type === "application") {
          res = await user_get_pplication();
        } else {
          res = await user_company_details(userId);
        }
        if (isMounted) setData(res?.data);
        setLoading(false);
        return;
      }

      // Original logic for other user types
      if (userRole == 5 || userRole == 6) {
        const res = await user_company_details(userId);
        if (isMounted) setData(res?.data);
      } else if (userRole == 8) {
        const res = await user_institutions_detail(id);
        if (isMounted) setData(res?.data);
      } else if (userRole == 9) {
        const res = await user_resource_detail(userId);
        if (isMounted) setData(res?.data[0]);
      } else if (userRole == 10) {
        const res = await user_expert_detail(userId);
        if (isMounted) setData(res?.data[0]);
      } else if (userRole == 4 || userRole == 0) {
        const res = await user_get_pplication();
        if (isMounted) setData(res.data);
      } else if (userRole == 24) {
        const res = await user_get_vendor_detail(
          props?.userDetails?.user?.id,
        );
        if (isMounted) setData(res.data);
      } else if (userRole == 20) {
        const res = await user_get_candidate_details(id);
        if (isMounted) setData(res.data);
      }
    } catch (e) {
      // no-op; optionally log
    } finally {
      if (isMounted) setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    loadData(mounted);
    return () => {
      mounted = false;
    };
  }, []);

  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const fileDownload = (data) => {
    let url = `${result}/${data}`;
    window.open(url, "_blank");
  };

  const handleUploadLogo = async () => {
    if (!data?.id) return;
    const { value: confirmed } = await Swal.fire({
      title: "Upload Logo",
      html:
        '<input id="swal-logo" type="file" class="swal2-file" accept=".jpg,.jpeg,.png" />' +
        '<div class="text-muted" style="font-size:12px;margin-top:6px;">Allowed: JPG/JPEG/PNG</div>',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Upload",
      confirmButtonColor: "#0A223D",
      preConfirm: () => {
        const fileInput = document.getElementById("swal-logo");
        const file = fileInput && fileInput.files && fileInput.files[0];
        if (!file) {
          Swal.showValidationMessage("Please choose a logo file");
          return false;
        }
        const validTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!validTypes.includes(file.type)) {
          Swal.showValidationMessage(
            "Invalid file type. Please upload JPG or PNG",
          );
          return false;
        }
        return file;
      },
    });

    if (confirmed) {
      try {
        const fileInput = document.getElementById("swal-logo");
        const file = fileInput.files[0];
        const form = new FormData();
        form.append("logo", file);
        if (userRole === 0) {
          await upload_application_logo(data.id, form);
        } else {
          await upload_company_logo(data.user_id, form);
        }
        if (userRole == 4 || userRole == 5 || userRole == 6) {
          const res = await user_company_details(data.user_id || userId);
          setData(res.data);
        } else if (userRole == 0) {
          const res = await user_get_pplication();
          setData(res.data);
        } else {
          setData((prev) => ({ ...prev, logo: "uploaded" }));
        }
        Swal.fire({ icon: "success", title: "Logo uploaded" });
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Upload failed",
          text: e?.message || "",
        });
      }
    }
  };
  const fullfileDownload = (data) => {
    let url = `${data}`;
    window.open(url, "_blank");
  };
  const handleDownloadExpCert = (data) => {
    let path = `${result}${data}`;
    window.open(path, "_blank");
    return;
  };
  const handleAddFinancialRecord = async () => {
    if (!data?.id) {
      return;
    }
    const now = new Date();
    const currYear = now.getFullYear();
    const fyOptions = [];
    const startYear = 2024; // Start from FY 2024-2025

    // Get existing financial years from data
    const existingYears = data?.financial_records?.map(record => record.financial_year) || [];

    for (let i = startYear; i <= currYear; i++) {
      const fyOption = `${i}-${i + 1}`;
      // Only add option if this financial year doesn't exist in records
      if (!existingYears.includes(fyOption)) {
        fyOptions.push(`<option value="${fyOption}">${fyOption}</option>`);
      }
    }
    const { value: formValues } = await Swal.fire({
      title: `<span style="font-size: 18px;">${data?.company_status === "existing_company" && data?.company_type === "kerala" ? "Add Records" : "Add Financial Record"}</span>`,
      width: "700px",
      html:
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Financial Year <span style="color: red;">*</span></label>' +
        '<select id="swal-year" class="form-select" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
        fyOptions.join("") +
        '</select>' +
        '</div>' +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">FY Turnover (in Crores) <span style="color: red;">*</span></label>' +
        '<input id="swal-turnover" type="number" step="0.01" class="form-control" placeholder="Enter turnover in crores" ' +
        'oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" ' +
        'style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da; margin-bottom: 20px;">' +
        '</div>' +
        (data?.company_status === "existing_company" && data?.company_type === "kerala" ?
          '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Remark</label>' +
          '<input id="swal-remark" type="text" class="form-control" placeholder="Enter remark" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          '</div>' : '') +
        (data?.company_status === "existing_company" && data?.company_type === "kerala" ?
          '<div class="form-group mb-3">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Capital Investment (in Crores)</label>' +
          '<input id="swal-capital" type="number" step="0.01" class="form-control" placeholder="Enter capital investment in crores" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          '</div>' +
          '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Male <span style="color: red;">*</span></label>' +
          '<input id="swal-male" type="number" class="form-control" placeholder="Enter male count" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          '</div>' +
          '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Female <span style="color: red;">*</span></label>' +
          '<input id="swal-female" type="number" class="form-control" placeholder="Enter female count" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          '</div>' +
          '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Genderqueer <span style="color: red;">*</span></label>' +
          '<input id="swal-genderqueer" type="number" class="form-control" placeholder="Enter genderqueer count" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          '</div>' +
          '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">SC/ST <span style="color: red;">*</span></label>' +
          '<input id="swal-scst" type="number" class="form-control" placeholder="Enter SC/ST count" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          '</div>' +
          '<div class="form-group mb-3">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">PWD <span style="color: red;">*</span></label>' +
          '<input id="swal-pwd" type="number" class="form-control" placeholder="Enter PWD count" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          '</div>'
          : ''),
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Save",
      confirmButtonColor: "#0A223D",
      cancelButtonColor: "#6c757d",
      didOpen: (el) => {
        const confirmBtn = document.querySelector(".swal2-confirm");
        const cancelBtn = document.querySelector(".swal2-cancel");
        if (confirmBtn) {
          confirmBtn.style.minWidth = "120px";
        }
        if (cancelBtn) {
          cancelBtn.style.minWidth = "120px";
        }

        // Apply scroll only for existing companies (more fields)
        if (data?.company_status === "existing_company" && el) {
          // el.style.maxHeight = '80vh';
          el.style.height = 'auto';
          const htmlContainer = el.querySelector('.swal2-html-container');
          if (htmlContainer) {
            htmlContainer.style.maxHeight = '60vh';
            htmlContainer.style.overflowY = 'auto';
          }
        }
      },
      preConfirm: () => {
        const year = (document.getElementById("swal-year").value || "").trim();
        const turnover = document.getElementById("swal-turnover").value;

        if (!year) {
          Swal.showValidationMessage("Please select a financial year");
          return false;
        }
        if (!turnover) {
          Swal.showValidationMessage("Please enter turnover");
          return false;
        }

        const turnoverParts = String(turnover).split(".");
        if (turnoverParts[0] && turnoverParts[0].length > 6) {
          Swal.showValidationMessage("Turnover cannot exceed 6 digits");
          return false;
        }

        const formValues = {
          financial_year: year,
          fy_turnover: turnover
        };

        if (data?.company_status === "existing_company" && data?.company_type === "kerala") {
          const male = document.getElementById("swal-male")?.value || "";
          const female = document.getElementById("swal-female")?.value || "";
          const genderqueer = document.getElementById("swal-genderqueer")?.value || "";
          const sc_st = document.getElementById("swal-scst")?.value || "";
          const pwd = document.getElementById("swal-pwd")?.value || "";

          if (!male || !female || !genderqueer || !sc_st || !pwd) {
            Swal.showValidationMessage("Please fill all employment fields (Male, Female, Genderqueer, SC/ST, PWD)");
            return false;
          }

          const employmentFields = [
            { label: "Male", value: String(male) },
            { label: "Female", value: String(female) },
            { label: "Genderqueer", value: String(genderqueer) },
            { label: "SC/ST", value: String(sc_st) },
            { label: "PWD", value: String(pwd) },
          ];
          const tooLong = employmentFields.find((f) => f.value.replace(/[^0-9]/g, "").length > 6);
          if (tooLong) {
            Swal.showValidationMessage(`${tooLong.label} cannot exceed 6 digits`);
            return false;
          }

          const capitalInvestment = document.getElementById("swal-capital")?.value || "";
          if (capitalInvestment) {
            const capitalParts = String(capitalInvestment).split(".");
            if (capitalParts[0] && capitalParts[0].length > 6) {
              Swal.showValidationMessage("Capital investment cannot exceed 6 digits");
              return false;
            }
          }

          formValues.capital_investment = capitalInvestment;
          formValues.remarks = (document.getElementById("swal-remark")?.value || "").trim();
          formValues.dir_employ_male = male;
          formValues.dir_employ_female = female;
          formValues.dir_employ_others = genderqueer;
          formValues.dir_employ_sc_st = sc_st;
          formValues.dir_employ_pwd = pwd;
        }

        return formValues;
      },
      showCancelButton: true,
      confirmButtonText: "Save",
      confirmButtonColor: "#0A223D",
    });

    if (formValues) {
      try {
        await add_financial_record(data.id, formValues);
        loadData(true);
        Swal.fire({ icon: "success", title: "Saved" });
      } catch (e) {
        const errorMsg =
          e?.response?.data?.message || e?.message || "Failed to save";
        Swal.fire({ icon: "error", title: "Failed to save", text: errorMsg });
      }
    }
  };

  const handleEditFinancialRecord = async (row) => {
    if (!data?.id) {
      return;
    }
    const { value: formValues } = await Swal.fire({
      title: '<span style="font-size: 18px;">Edit Financial Record</span>',
      width: "700px",
      html:
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Financial Year<span style="color: red;">*</span></label>' +
        `<input id="swal-year" class="form-control" value="${row.financial_year || ""}" disabled style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da; background-color: #f8f9fa;margin-bottom: 20px;">` +
        '</div>' +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">FY Turnover (in Crores) <span style="color: red;">*</span></label>' +
        `<input id="swal-turnover" type="number" step="0.01" class="form-control" placeholder="Enter turnover in crores" value="${row.fy_turnover || ""}" ` +
        'style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;"margin-bottom: 20px;">' +
        '</div>' +
        (data?.company_status === "existing_company" && data?.company_type === "kerala" ?
          '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Remark</label>' +
          `<input id="swal-remark" type="text" class="form-control" placeholder="Enter remark" value="${row.remarks || ""}" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
          '</div>' : '') +
        (data?.company_status === "existing_company" && data?.company_type === "kerala" ?
          '<div class="form-group mb-3">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Capital Investment (in Crores)</label>' +
          `<input id="swal-capital" type="number" step="0.01" class="form-control" placeholder="Enter capital investment in crores" value="${row.capital_investment || ""}" ` +
          'style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          '</div>'
          : ''),
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Update",
      confirmButtonColor: "#0A223D",
      cancelButtonColor: "#6c757d",
      didOpen: () => {
        const confirmBtn = document.querySelector(".swal2-confirm");
        const cancelBtn = document.querySelector(".swal2-cancel");
        if (confirmBtn) {
          confirmBtn.style.minWidth = "120px";
        }
        if (cancelBtn) {
          cancelBtn.style.minWidth = "120px";
        }

        // Add input validation for turnover field
        const turnoverInput = document.getElementById("swal-turnover");
        if (turnoverInput) {
          turnoverInput.addEventListener('input', function (e) {
            // Save cursor position
            const cursorPos = this.selectionStart;
            const oldValue = this.value;

            // Remove non-numeric characters except decimal point
            let newValue = this.value.replace(/[^0-9.]/g, '');

            // Limit to 6 digits before decimal
            const parts = newValue.split('.');
            if (parts[0] && parts[0].length > 6) {
              parts[0] = parts[0].slice(0, 6);
              newValue = parts.join('.');
            }

            // Update value if changed
            if (oldValue !== newValue) {
              this.value = newValue;
              // Restore cursor position
              this.setSelectionRange(cursorPos, cursorPos);
            }
          });
        }

        // Add input validation for capital field
        const capitalInput = document.getElementById("swal-capital");
        if (capitalInput) {
          capitalInput.addEventListener('input', function (e) {
            // Save cursor position
            const cursorPos = this.selectionStart;
            const oldValue = this.value;

            // Remove non-numeric characters except decimal point
            let newValue = this.value.replace(/[^0-9.]/g, '');

            // Limit to 6 digits before decimal
            const parts = newValue.split('.');
            if (parts[0] && parts[0].length > 6) {
              parts[0] = parts[0].slice(0, 6);
              newValue = parts.join('.');
            }

            // Update value if changed
            if (oldValue !== newValue) {
              this.value = newValue;
              // Restore cursor position
              this.setSelectionRange(cursorPos, cursorPos);
            }
          });
        }
      },
      preConfirm: () => {
        const year = (document.getElementById("swal-year").value || "").trim();
        const turnover = document.getElementById("swal-turnover").value;

        if (!turnover) {
          Swal.showValidationMessage("Please enter turnover");
          return false;
        }

        const turnoverParts = String(turnover).split(".");
        if (turnoverParts[0] && turnoverParts[0].length > 6) {
          Swal.showValidationMessage("Turnover cannot exceed 6 digits");
          return false;
        }

        const formValues = {
          financial_year: year,
          fy_turnover: turnover,
          // Preserve existing employment data
          dir_employ_male: row.dir_employ_male || "",
          dir_employ_female: row.dir_employ_female || "",
          dir_employ_others: row.dir_employ_others || "",
          dir_employ_sc_st: row.dir_employ_sc_st || "",
          dir_employ_pwd: row.dir_employ_pwd || ""
        };

        // Handle remark field - always shown now
        const remarkValue = (document.getElementById("swal-remark")?.value || "").trim();
        formValues.remarks = remarkValue || null;

        if (data?.company_status === "existing_company") {
          const capitalInvestment = document.getElementById("swal-capital")?.value || "";
          if (capitalInvestment) {
            const capitalParts = String(capitalInvestment).split(".");
            if (capitalParts[0] && capitalParts[0].length > 6) {
              Swal.showValidationMessage("Capital investment cannot exceed 6 digits");
              return false;
            }
          }
          // Always include capital_investment for existing companies
          // Send 0 if cleared to remove the value
          formValues.capital_investment = capitalInvestment || "0";
        }

        return formValues;
      },
      showCancelButton: true,
      confirmButtonText: "Update",
      confirmButtonColor: "#0A223D",
    });

    if (formValues) {
      try {
        await update_financial_record(data.id, row.financial_year, formValues);
        loadData(true);
        Swal.fire({ icon: "success", title: "Updated" });
      } catch (e) {
        const errorMsg =
          e?.response?.data?.message || e?.message || "Failed to update";
        Swal.fire({ icon: "error", title: "Failed to update", text: errorMsg });
      }
    }
  };

  const handleEditEmploymentRecord = async (row) => {
    if (!data?.id) {
      return;
    }
    const { value: formValues } = await Swal.fire({
      title: '<span style="font-size: 18px;">Edit Employment Record</span>',
      width: "700px",
      html:
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Financial Year</label>' +
        `<input id="swal-year" class="form-control" value="${row.financial_year || ""}" disabled style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da; background-color: #f8f9fa;margin-bottom: 20px;">` +
        '</div>' +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Male <span style="color: red;">*</span></label>' +
        `<input id="swal-male" type="number" class="form-control" placeholder="Enter male count" value="${row.dir_employ_male || ""}" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
        '</div>' +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Female <span style="color: red;">*</span></label>' +
        `<input id="swal-female" type="number" class="form-control" placeholder="Enter female count" value="${row.dir_employ_female || ""}" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
        '</div>' +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Genderqueer <span style="color: red;">*</span></label>' +
        `<input id="swal-genderqueer" type="number" class="form-control" placeholder="Enter genderqueer count" value="${row.dir_employ_others || ""}" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
        '</div>' +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">SC/ST <span style="color: red;">*</span></label>' +
        `<input id="swal-scst" type="number" class="form-control" placeholder="Enter SC/ST count" value="${row.dir_employ_sc_st || ""}" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
        '</div>' +
        '<div class="form-group mb-3">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">PWD <span style="color: red;">*</span></label>' +
        `<input id="swal-pwd" type="number" class="form-control" placeholder="Enter PWD count" value="${row.dir_employ_pwd || ""}" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
        '</div>',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Update",
      confirmButtonColor: "#0A223D",
      cancelButtonColor: "#6c757d",
      didOpen: () => {
        const confirmBtn = document.querySelector(".swal2-confirm");
        const cancelBtn = document.querySelector(".swal2-cancel");
        if (confirmBtn) {
          confirmBtn.style.minWidth = "120px";
        }
        if (cancelBtn) {
          cancelBtn.style.minWidth = "120px";
        }
      },
      preConfirm: () => {
        const male = document.getElementById("swal-male").value;
        const female = document.getElementById("swal-female").value;
        const genderqueer = document.getElementById("swal-genderqueer").value;
        const sc_st = document.getElementById("swal-scst").value;
        const pwd = document.getElementById("swal-pwd").value;

        if (!male || !female || !genderqueer || !sc_st || !pwd) {
          Swal.showValidationMessage("Please fill all employment fields (Male, Female, Genderqueer, SC/ST, PWD)");
          return false;
        }

        return {
          financial_year: row.financial_year,
          fy_turnover: row.fy_turnover || "",
          capital_investment: row.capital_investment || "",
          remark: row.remarks || "",
          dir_employ_male: male,
          dir_employ_female: female,
          dir_employ_others: genderqueer,
          dir_employ_sc_st: sc_st,
          dir_employ_pwd: pwd
        };
      },
    });

    if (formValues) {
      try {
        await update_financial_record(data.id, row.financial_year, formValues);
        loadData(true);
        Swal.fire({ icon: "success", title: "Updated" });
      } catch (e) {
        const errorMsg =
          e?.response?.data?.message || e?.message || "Failed to update";
        Swal.fire({ icon: "error", title: "Failed to update", text: errorMsg });
      }
    }
  };

  return (
    <>
      <div className="dahContent-header-section">Application Details</div>

      <div className="dash-details-body">
        <div className="dash-datas">
          <div className="dash-items-data">
            {(data?.company_name || data?.parent_company?.name) && (
              <div className="row">
                <div className="col-3">Company Name</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {(() => {
                    const name = data?.company_name || data?.parent_company?.name;
                    if (!name || typeof name !== "string") return name;
                    return name.charAt(0).toUpperCase() + name.slice(1);
                  })()}
                </div>
              </div>
            )}

            {/* {data?.application_id !== undefined &&
              data?.application_id !== null &&
              data?.application_id !== "" &&
              data?.application_id !== 0 &&
              data?.application_id !== "0" && (
                <div className="row">
                  <div className="col-3">Application ID</div>
                  <div className="col-1">:</div>
                  <div className="col-8">{data?.application_id}</div>
                </div>
              )}

            {data?.unique_application_ref_no && (
              <div className="row">
                <div className="col-3">Reference No</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.unique_application_ref_no || "Not Assigned"}</div>
              </div>
            )} */}
            {(data?.unique_application_ref_no || data?.company?.unique_application_ref_no) && (
              <div className="row">
                <div className="col-3">Application ID</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.company?.unique_application_ref_no || data?.unique_application_ref_no}
                </div>
              </div>
            )}

            {data?.application_status !== undefined && (
              <div className="row">
                <div className="col-3">Application Status</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.application_status === 7 ? "Agreement Executed" :
                    data?.application_status === 8 ? "Completed" :
                      data?.application_status === 16 ? "Waiting" :
                        data?.application_status === 15 ? "Suggestion" :
                          data?.application_status === 6 ? "Agreement Execution" :
                            data?.application_status === 2 ? "Accepted" :
                              data?.application_status === 1 ? "In Progress" :
                                data?.application_status === 0 ? "Submitted" :
                                  data?.application_status === 5 ? "Reverted" :
                                    data?.application_status === 4 ? "Rejected" : "Unknown"}
                </div>
              </div>
            )}

            {data?.person_name && (
              <div className="row">
                <div className="col-3">Contact Person</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.person_name}</div>
              </div>
            )}

            {data?.person_designation && (
              <div className="row">
                <div className="col-3">Person Designation</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.person_designation}</div>
              </div>
            )}

            {data?.address && (
              <div className="row">
                <div className="col-3">Company Address</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.address}</div>
              </div>
            )}

            {data?.phone_no && (
              <div className="row">
                <div className="col-3">Company Phone</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.phone_no}</div>
              </div>
            )}

            {data?.email && (
              <div className="row">
                <div className="col-3">Company Email</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.email}</div>
              </div>
            )}

            {data?.alternate_phone && (
              <div className="row">
                <div className="col-3">Alternate Phone</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.alternate_phone}</div>
              </div>
            )}

            {data?.alternate_email && (
              <div className="row">
                <div className="col-3">Alternate Email</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.alternate_email}</div>
              </div>
            )}

            {data?.capital_investment && (
              <div className="row">
                <div className="col-3">Capital Investment</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.capital_investment}</div>
              </div>
            )}

            {data?.ex_man_power && (
              <div className="row">
                <div className="col-3">Existing Manpower</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.ex_man_power}</div>
              </div>
            )}

            {data?.area_type && (
              <div className="row">
                <div className="col-3">Area Type</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.area_type?.replace(/_/g, ' ').toUpperCase()}
                </div>
              </div>
            )}

            {data?.financial_year && (
              <div className="row">
                <div className="col-3">Financial Year</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.financial_year}</div>
              </div>
            )}

            {data?.fy_turnover && (
              <div className="row">
                <div className="col-3">FY Turnover</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.fy_turnover || "Not Provided"}</div>
              </div>
            )}

            {data?.cin_number && (
              <div className="row">
                <div className="col-3">CIN Number</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.cin_number}</div>
              </div>
            )}

            {data?.site_link && (
              <div className="row">
                <div className="col-3">Website</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  <a href={data?.site_link} target="_blank" rel="noopener noreferrer" className="text-primary">
                    Visit Website
                  </a>
                </div>
              </div>
            )}

            {data?.abstract_project_proposal && (
              <div className="row">
                <div className="col-3">Project Proposal</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.abstract_project_proposal}</div>
              </div>
            )}

            {data?.upload_proposal && (
              <div className="row">
                <div className="col-3">Proposal Document</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  <span
                    className="text-primary"
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.open(`${props.url}/${data?.upload_proposal}`, '_blank')}
                  >
                    View {data?.file_name || "Proposal"}
                  </span>
                </div>
              </div>
            )}

            {!data?.is_company_user && (data?.logo || (userRole === 0 || userRole === 5 || userRole === 6 || userRole === 4 || userRole === 7)) ? (
              <div className="row mb-3 align-items-center">
                <div className="col-3">Company Logo</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  <div className="d-flex align-items-center flex-wrap" style={{ gap: '15px' }}>
                    {/* {data?.logo && (
                      // <div className="mb-2">
                      //   <img 
                      //     src={`${props.url}/${data?.logo}`} 
                      //     // alt="Company Logo" 
                      //     style={{ maxWidth: '120px', maxHeight: '60px', objectFit: 'contain' }}
                      //   />
                      // </div>
                    )} */}
                    {!loading && (userRole === 0 || userRole === 5 || userRole === 6 || userRole === 4 || userRole === 7) && (
                      <div className="d-flex flex-wrap" style={{ gap: '10px' }}>
                        {data?.logo && (
                          <button
                            className="btn btn-approve btn-success ovr"
                            onClick={() => fullfileDownload(`${props.url}/${data?.logo}`)}
                          >
                            Download Logo
                          </button>
                        )}

                        {!props.companyData?.is_company_user && (
                          <button
                            className="btn btn-approve btn-success ovr"
                            onClick={handleUploadLogo}
                          >
                            Update Logo
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : null}

            {/* Domain Types */}
            {data?.domain_types && data?.domain_types?.length > 0 && (
              <div className="row">
                <div className="col-3">Domain Types</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.domain_types?.map((domain, index) => (
                    <div key={domain.id} style={{ marginBottom: '4px' }}>
                      • {domain.domain_name}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Product Profiles */}
            {data?.product_profiles && data?.product_profiles?.length > 0 && (
              <div className="row">
                <div className="col-3">Products</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.product_profiles?.map((product, index) => (
                    <div key={product.id} style={{ marginBottom: '8px' }}>
                      <strong>{product.product_name}</strong>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        {ReactHtmlParser(product.product_desc)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Area Management */}
            {data?.area_management && data?.area_management?.length > 0 && (
              <div className="row">
                <div className="col-3">Area Details</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.area_management?.map((area, index) => (
                    <div key={area.id} style={{ marginBottom: '8px' }}>
                      <strong>{area.location}</strong> - {area.area_type?.replace(/_/g, ' ').toUpperCase()}
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        Area: {area.area_in_sqft} sq ft | Block: {area.block_no} | Survey: {area.survey_no}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        Village: {area.village_name} | Holding: {area.nature_of_holding}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Dates */}
            {data?.application_submitted_at && (
              <div className="row">
                <div className="col-3">Submitted At</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.application_submitted_at ? moment(data?.application_submitted_at).format('DD-MMM-YYYY HH:mm') : "Not Submitted"}
                </div>
              </div>
            )}

            {data?.approved_at && (
              <div className="row">
                <div className="col-3">Approved At</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.approved_at ? moment(data?.approved_at).format('DD-MMM-YYYY HH:mm') : "Not Approved"}
                </div>
              </div>
            )}

            {data?.created_at && (
              <div className="row">
                <div className="col-3">Created At</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {moment(data?.created_at).format('DD-MMM-YYYY HH:mm')}
                </div>
              </div>
            )}

            {/* {(data?.unique_application_ref_no || data?.company?.unique_application_ref_no) && (
              <div className="row">
                <div className="col-3">Application ID</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.company?.unique_application_ref_no || data?.unique_application_ref_no}
                </div>
              </div>
            )} */}
            {data?.native_kerala && data?.native_kerala == 1 && (
              <div className="row">
                <div className="col-3">Are you a Native Keralite?</div>
                <div className="col-1">:</div>
                <div className="col-8">Yes</div>
              </div>
            )}
            {data?.native_kerala && data?.native_kerala == 0 && (
              <div className="row">
                <div className="col-3">Are you a Native Keralite?</div>
                <div className="col-1">:</div>
                <div className="col-8">No</div>
              </div>
            )}
            {data?.identity_type && (
              <div className="row">
                <div className="col-3">Identity Type</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.identity_type}</div>
              </div>
            )}
            {data?.identity_no && (
              <div className="row">
                <div className="col-3">Identity No</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.identity_no}</div>
              </div>
            )}

            {/* Company User Specific Fields */}
            {data?.is_company_user && data?.company_user_role && (
              <div className="row">
                <div className="col-3">Company Role</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.company_user_role}</div>
              </div>
            )}

            {data?.is_company_user && data?.parent_company?.status !== undefined && (
              <div className="row">
                <div className="col-3">Company Status</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.parent_company?.status === 2 ? "Accepted" :
                    data?.parent_company?.status === 1 ? "In Progress" :
                      data?.parent_company?.status === 0 ? "Submitted" :
                        data?.parent_company?.status === 4 ? "Rejected" : "Unknown"}
                </div>
              </div>
            )}

            {data?.is_company_user && data?.parent_company?.email && (
              <div className="row">
                <div className="col-3">Company Email</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.parent_company?.email}</div>
              </div>
            )}

            {data?.is_company_user && data?.parent_company?.phone_no && (
              <div className="row">
                <div className="col-3">Company Phone</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.parent_company?.phone_no}</div>
              </div>
            )}

            {/* Company User Personal Information */}
            {data?.is_company_user && data?.name && (
              <div className="row">
                <div className="col-3">Your Name</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.name}</div>
              </div>
            )}

            {data?.is_company_user && data?.email && (
              <div className="row">
                <div className="col-3">Your Email</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.email}</div>
              </div>
            )}

            {data?.is_company_user && data?.mobile_number && (
              <div className="row">
                <div className="col-3">Your Mobile</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.mobile_number}</div>
              </div>
            )}

            {/* Additional Company User Details */}
            {data?.is_company_user && data?.company_user_status !== undefined && (
              <div className="row">
                <div className="col-3">User Status</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.company_user_status === 1 ? "Active" : "Inactive"}
                </div>
              </div>
            )}

            {data?.is_company_user && data?.company_user_last_login_at && (
              <div className="row">
                <div className="col-3">Last Login</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {moment(data?.company_user_last_login_at).format('DD-MMM-YYYY HH:mm')}
                </div>
              </div>
            )}

            {data?.is_company_user && data?.parent_company?.company_type && (
              <div className="row">
                <div className="col-3">Company Type</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.parent_company?.company_type?.toUpperCase()}
                </div>
              </div>
            )}

            {data?.is_company_user && data?.parent_company?.application_id && (
              <div className="row">
                <div className="col-3">Application ID</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.parent_company?.application_id}</div>
              </div>
            )}

            {data?.is_company_user && data?.company?.person_name && (
              <div className="row">
                <div className="col-3">Contact Person</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.company?.person_name}</div>
              </div>
            )}

            {data?.is_company_user && data?.company?.person_designation && (
              <div className="row">
                <div className="col-3">Person Designation</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.company?.person_designation}</div>
              </div>
            )}

            {data?.is_company_user && data?.company?.address && (
              <div className="row">
                <div className="col-3">Company Address</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.company?.address}</div>
              </div>
            )}

            {data?.is_company_user && data?.company?.area_type && (
              <div className="row">
                <div className="col-3">Area Type</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.company?.area_type?.replace(/_/g, ' ').toUpperCase()}
                </div>
              </div>
            )}

            {data?.is_company_user && data?.company?.ex_man_power && (
              <div className="row">
                <div className="col-3">Existing Manpower</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.company?.ex_man_power}</div>
              </div>
            )}

            {data?.is_company_user && data?.company?.project_status !== undefined && (
              <div className="row">
                <div className="col-3">Project Status</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.company?.project_status === 2 ? "In Progress" :
                    data?.company?.project_status === 1 ? "Submitted" :
                      data?.company?.project_status === 0 ? "Pending" : "Unknown"}
                </div>
              </div>
            )}

            {data?.is_company_user && data?.company?.upload_proposal && (
              <div className="row">
                <div className="col-3">Proposal Document</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  <span
                    className="text-primary"
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.open(`${props.url}/${data?.company?.upload_proposal}`, '_blank')}
                  >
                    View Proposal
                  </span>
                </div>
              </div>
            )}

            {data?.is_company_user && data?.created_at && (
              <div className="row">
                <div className="col-3">User Created</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {moment(data?.created_at).format('DD-MMM-YYYY')}
                </div>
              </div>
            )}

            {data?.identity_file && (
              <div className="row">
                <div className="col-3">Identity Number</div>
                <div className="col-1">:</div>
                <div
                  className="col-8 ovr text-warning"
                  onClick={() => fullfileDownload(data?.identity_file)}
                >
                  Download
                </div>
              </div>
            )}
            {data?.native_kerala == 0 && (
              <div className="row">
                <div className="col-3">Are you a Non Resident Keralite?</div>
                <div className="col-1">:</div>
                <div className="col-8">Yes</div>
              </div>
            )}
            {data?.native_kerala == 0 && data?.native_address_type && (
              <div className="row">
                <div className="col-3">Proof of Native Address</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.native_address_type}</div>
              </div>
            )}
            {data?.native_kerala == 0 && data?.native_address_type && (
              <div className="row">
                <div className="col-3">Uploaded Proof of Native Address</div>
                <div className="col-1">:</div>
                <div
                  className="col-8 ovr text-warning"
                  onClick={() => fullfileDownload(data?.non_keralite_file)}
                >
                  Download
                </div>
              </div>
            )}

            {data?.name && (
              <div className="row">
                <div className="col-3">Name</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.prefix} {data?.name}
                </div>
              </div>
            )}
            {data?.dob && (
              <div className="row">
                <div className="col-3">Date of Birth</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.dob}</div>
              </div>
            )}
            {data?.category && (
              <div className="row">
                <div className="col-3">Manpower Type</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.category}</div>
              </div>
            )}
            {data?.fresher && (
              <div className="row">
                <div className="col-3">Fresher</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.fresher}</div>
              </div>
            )}
            {data?.full_name && (
              <div className="row">
                <div className="col-3">Full Name</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.full_name}</div>
              </div>
            )}
            {data?.cin_number && (
              <div className="row">
                <div className="col-3">Registration Number / CIN Number</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.cin_number}</div>
              </div>
            )}
            <>
              {data?.title && (
                <>
                  <div className="row">
                    <div className="col-3">Name</div>
                    <div className="col-1">:</div>
                    <div className="col-8">
                      {data?.title ? data?.title + "." : "Mr."}{" "}
                      {data?.first_name ?? ""} {data?.last_name ?? ""}
                    </div>
                  </div>
                </>
              )}
            </>
            {data?.gender && data?.gender !== "" && userRole != 20 && (
              <div className="row">
                <div className="col-3">Gender</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.gender == 1
                    ? "Male"
                    : data?.gender == 2
                      ? "Female"
                      : "Others"}
                </div>
              </div>
            )}
            {data?.gender && data?.gender !== "" && userRole == 20 && (
              <div className="row">
                <div className="col-3">Gender</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.gender}</div>
              </div>
            )}

            {data?.institution_name && (
              <div className="row">
                <div className="col-3">Institution Name</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.institution_name}</div>
              </div>
            )}
            {data?.headquaters_detail && (
              <div className="row">
                <div className="col-3">HQ Details</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.headquaters_detail}</div>
              </div>
            )}
            {data?.registration_date && (
              <div className="row">
                <div className="col-3">Registration Date</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.registration_date}</div>
              </div>
            )}
            {data?.affiliation && (
              <div className="row">
                <div className="col-3">
                  Affiliation Details with Affiliation Number
                </div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.affiliation}</div>
              </div>
            )}
            {data?.contact_person_details && (
              <div className="row">
                <div className="col-3">Contact Person Details</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.contact_person_details}</div>
              </div>
            )}
            {data?.file_registration_proof &&
              data?.file_registration_proof !== "" && (
                <div className="row">
                  <div className="col-3">Registration Proof</div>
                  <div className="col-1">:</div>
                  <div className="col-8">
                    <button
                      onClick={() => {
                        fileDownload(data?.file_registration_proof);
                      }}
                    >
                      View
                    </button>
                  </div>
                </div>
              )}

            {data?.total_students && (
              <div className="row">
                <div className="col-3">Total Students</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.total_students}</div>
              </div>
            )}
            {data?.person_name && (
              <div className="row">
                <div className="col-3">Contact Person Name</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.person_name}</div>
              </div>
            )}
            {data?.date_of_birth && (
              <div className="row">
                <div className="col-3">Date of Birth</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.date_of_birth
                    ? moment(data?.date_of_birth, "YYYY-MM-DD").format(
                      "DD-MM-YYYY",
                    )
                    : ""}
                </div>
              </div>
            )}
            {data?.person_designation && (
              <div className="row">
                <div className="col-3">Contact Person Designation</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.person_designation}</div>
              </div>
            )}
            {data?.address && (
              <div className="row">
                <div className="col-3">Address</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.address}</div>
              </div>
            )}
            {data?.phone && (
              <div className="row">
                <div className="col-3">Phone</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.phone}</div>
              </div>
            )}

            {data?.email && (
              <div className="row">
                <div className="col-3">Email</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.email}</div>
              </div>
            )}
            {data?.marital_status && (
              <div className="row">
                <div className="col-3">Marital Status</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.marital_status}</div>
              </div>
            )}
            {data?.parent_name && (
              <div className="row">
                <div className="col-3">Parent / Spouse</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.parent_name}</div>
              </div>
            )}
            {data?.caste && (
              <div className="row">
                <div className="col-3">Category</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.caste}</div>
              </div>
            )}
            {data?.handicapped && (
              <div className="row">
                <div className="col-3">Physiclly Challenged</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.handicapped}</div>
              </div>
            )}
            {data?.handicapped == "Yes" && data?.handicapped_file && (
              <div className="row">
                <div className="col-3">Disability Certificate</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.handicapped_file}</div>
              </div>
            )}
            {data?.site_link && (
              <div className="row">
                <div className="col-3">Website Link</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.site_link}</div>
              </div>
            )}
            {data?.phone_no && (
              <div className="row">
                <div className="col-3">Phone no</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.phone_no}</div>
              </div>
            )}
            {data?.contact && (
              <div className="row">
                <div className="col-3">Phone no</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.contact}</div>
              </div>
            )}
            {data?.alt_contact && (
              <div className="row">
                <div className="col-3">Alternate Phone no</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.alt_contact}</div>
              </div>
            )}
            {data?.alt_email && (
              <div className="row">
                <div className="col-3">Alternate Email</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.alt_email}</div>
              </div>
            )}
            {data?.pin_code && (
              <div className="row">
                <div className="col-3">Pin Code</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.pin_code}</div>
              </div>
            )}
            {data?.blood_group && (
              <div className="row">
                <div className="col-3">Blood Group</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.blood_group}</div>
              </div>
            )}
            {data?.other_blood_group && (
              <div className="row">
                <div className="col-3">Specify Blood Group</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.other_blood_group}</div>
              </div>
            )}

            {data?.photo && (
              <div className="row">
                <div className="col-3">Photo</div>
                <div className="col-1">:</div>
                <div
                  className="col-8 ovr text-warning"
                  onClick={() => fullfileDownload(data?.photo)}
                >
                  Download
                </div>
              </div>
            )}
            {data?.qualification_type && (
              <div className="row">
                <div className="col-3">Highest Qualification</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.qualification_type}</div>
              </div>
            )}
            {data?.qualification && (
              <div className="row">
                <div className="col-3">Qualification</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.qualification}</div>
              </div>
            )}
            {data?.alternate_phone && (
              <div className="row">
                <div className="col-3">Alternate Phone</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">
                  {data?.country_code &&
                    data?.country_code !== "null" &&
                    data?.country_code !== "undefined" &&
                    data?.alternate_phone &&
                    data?.country_code !== "" && <>{data?.country_code} - </>}

                  {data?.alternate_phone ?? ""}
                </div>
              </div>
            )}
            {data?.alternate_email && (
              <div className="row">
                <div className="col-3">Alternative Email</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.alternate_email}</div>
              </div>
            )}
            {data?.area_of_operation && (
              <div className="row">
                <div className="col-3">Area Of Operation</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.area_of_operation}</div>
              </div>
            )}
            {data?.company_description && (
              <div className="row">
                <div className="col-3">Company Description</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.company_description}</div>
              </div>
            )}

            {data?.upload_proposal && (
              <div className="row">
                <div className="col-3">Proposal</div>
                <div className="col-1">:</div>
                {/* <div className="col-8 ovr">{data?.logo}</div> */}
                <button
                  className="col-3 ovr btn btn-approve btn-success"
                  onClick={(e) => handleDownloadExpCert(data?.upload_proposal)}
                >
                  Download Proposal
                </button>
              </div>
            )}
            {data?.brochure && (
              <div className="row">
                <div className="col-3">Brochure</div>
                <div className="col-1">:</div>

                <button
                  className="col-3 ovr btn btn-approve btn-success"
                  onClick={(e) => handleDownloadExpCert(data?.brochure)}
                >
                  Download Brochure
                </button>
              </div>
            )}

            {/* {data?.sadmin_reason && (
              <div className="row">
                <div className="col-3">Reverted Reason by SA</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.sadmin_reason}</div>
              </div>
            )}
            {data?.admin_reason && (
              <div className="row">
                <div className="col-3">Reverted Reason by Admin</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.admin_reason}</div>
              </div>
            )} */}

            {data?.abstract_project_proposal &&
              (userRole === 0 || userRole === 4) && (
                <div className="row">
                  <div className="col-3">Abstract Project Proposal</div>
                  <div className="col-1">:</div>
                  <div className="col-8">{data?.abstract_project_proposal}</div>
                </div>
              )}
            {data?.abstract_project_proposal && userRole === 5 && (
              <div className="row">
                <div className="col-3">Abstract Company Profile</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.abstract_project_proposal}</div>
              </div>
            )}
            {data?.product_profiles && data?.product_profiles.length > 0 && (
              <div className="row">
                <div className="col-3">Product Profile</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.product_profiles.map((item) => (
                    <>
                      <div className="col-12 mb-1">
                        <b>{item.product_name ?? ""} </b> <br />
                        {ReactHtmlParser(item.product_desc)}
                      </div>
                      {/* <div className="col-12 mb-3 ">
                          <div>{ReactHtmlParser(item.product_desc)}</div>
                        </div> */}
                    </>
                  ))}
                </div>
              </div>
            )}
            {data?.company_status && (
              <div className="row">
                <div className="col-3">New company / Existing company ?</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">
                  {" "}
                  {data.company_status === "new_company"
                    ? "New Company"
                    : data.company_status === "existing_company"
                      ? "Existing Company"
                      : ""}
                </div>
              </div>
            )}
            {data?.application_status === 5 && (
              <div className="row">
                <div className="col-3">Reverted Message</div>
                <div className="col-1">:</div>
                <div className="col-8 ovr">{data?.user_message || ""}</div>
              </div>
            )}
            {!loading &&
              (userRole === 0 ||
                userRole === 4 ||
                userRole === 5 ||
                userRole === 7 ||
                userRole === 6 ||
                props?.companyData?.is_company_user) &&
              data?.financial_records && (
                <>
                  <div className="row mt-3">
                    <div className="col-8">
                      <h6 className="mb-0">
                        <b>Financial Records</b>
                      </h6>
                    </div>
                    {data?.company_status === "existing_company" && data?.company_type === "kerala" ? (
                      <div className="col-4 text-right">
                        <button
                          className="btn btn-approve btn-success btn-sm"
                          onClick={handleAddFinancialRecord}
                          disabled={props?.companyData?.is_company_user}
                        >
                          Add Records
                        </button>
                      </div>
                    ) : (
                      <div className="col-4 text-right">
                        <button
                          className="btn btn-approve btn-success btn-sm"
                          onClick={handleAddFinancialRecord}
                          disabled={props?.companyData?.is_company_user}
                        >
                          Add Financial Record
                        </button>
                      </div>
                    )}
                  </div>
                  <hr />
                  <div className="data">
                    <div className="row">
                      <div className="col-12 overflow-auto" style={{ padding: 0 }}>
                        <CustomTable
                          className="areatable"
                          {...props}
                          columns={[
                            {
                              title: "Financial Year",
                              field: "financial_year",
                            },
                            { title: "Turnover (Cr)", field: "fy_turnover" },
                            ...(data?.company_status === "existing_company" && data?.company_type === "kerala" ? [{ title: "Capital (Cr)", field: "capital_investment" }] : []),
                            ...(data?.company_status === "existing_company" && data?.company_type === "kerala" ? [{ title: "Remarks", field: "remarks" }] : []),

                            {
                              title: "Actions",
                              field: "actions",
                              render: (row) => (
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => handleEditFinancialRecord(row)}
                                  disabled={props?.companyData?.is_company_user}
                                >
                                  Edit
                                </button>
                              ),
                            },
                          ]}
                          data={data.financial_records}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Employment Details table based on financial_records */}
                  {(userRole === 4 || userRole === 5) && data?.company_status === "existing_company" && (
                    <>
                      <div className="row mt-4">
                        <div className="col-8">
                          <h6 className="mb-0">
                            <b>Employment Details</b>
                          </h6>
                        </div>
                      </div>
                      <hr />
                      <div className="data">
                        <div className="row">
                          <div className="col-12 overflow-auto">
                            <CustomTable
                              className="areatable"
                              {...props}
                              columns={[
                                {
                                  title: "Financial Year",
                                  field: "financial_year",
                                },
                                { title: "Male", field: "dir_employ_male" },
                                { title: "Female", field: "dir_employ_female" },
                                { title: "Genderqueer", field: "dir_employ_others" },
                                { title: "SC/ST", field: "dir_employ_sc_st" },
                                { title: "PWD", field: "dir_employ_pwd" },
                                {
                                  title: "Total Direct Employment",
                                  field: "direct_emp",
                                },
                                //  { title: "Remarks", field: "remarks" },
                                {
                                  title: "Actions",
                                  field: "actions",
                                  render: (row) => (
                                    <button
                                      className="btn btn-sm btn-primary"
                                      onClick={() => handleEditEmploymentRecord(row)}
                                      disabled={props?.companyData?.is_company_user}
                                    >
                                      Edit
                                    </button>
                                  ),
                                },

                              ]}
                              data={data.financial_records}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}

            {data?.courses && data?.courses.length > 0 && (
              <div className="row">
                <div className="col-3">Courses Offered</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.courses.map((item) => (
                    <>
                      <div className="col-12 mb-1">
                        <b>{item.course_type ?? ""} </b> :{" "}
                        {item.course_name ?? ""}{" "}
                      </div>
                      {/* <div className="col-12 mb-3 ">
                          <div>{ReactHtmlParser(item.product_desc)}</div>
                        </div> */}
                    </>
                  ))}
                </div>
              </div>
            )}
            {data?.domain_types && data?.domain_types?.length > 0 && (
              <div className="row">
                <div className="col-3">Domain Type</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.domain_types && (
                    <>
                      {data?.domain_types.map((dom, i) => (
                        <>
                          <div>{dom.domain_name}</div>
                        </>
                      ))}
                    </>
                  )}
                  {(data?.any_other_flag === 1 ||
                    (data?.any_other_flag &&
                      data?.any_other_domain !== "null")) && (
                      <div>{data?.any_other_domain}</div>
                    )}
                </div>
              </div>
            )}

            {data?.languages && data?.languages?.length > 0 && (
              <div className="row">
                <div className="col-3">Languages Known</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.languages && (
                    <>
                      {data?.languages?.map((dom, i) => (
                        <>
                          {i !== 0 && <> |&nbsp; </>}
                          {dom.language_name}
                        </>
                      ))}
                    </>
                  )}
                </div>
              </div>
            )}
            {data?.area_of_expertise && data?.area_of_expertise?.length > 0 && (
              <div className="row">
                <div className="col-3">Area of Expertise</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.area_of_expertise && (
                    <>
                      {data?.area_of_expertise?.map((dom, i) => (
                        <>
                          {i === 0 ? (
                            <>{dom.expertise_name} </>
                          ) : (
                            <> |&nbsp; {dom.expertise_name} </>
                          )}
                        </>
                      ))}
                    </>
                  )}
                </div>
              </div>
            )}
            {data?.interest_type && (
              <div className="row">
                <div className="col-3">Area of Interest</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.interest_type}</div>
              </div>
            )}
            {data?.interest && (
              <div className="row">
                <div className="col-3">Interests</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data && data?.interest && (
                    <>
                      {JSON.parse(data?.interest)?.map((item, index) => (
                        <div>{item}</div>
                      ))}
                      {data?.any_other_domain && (
                        <div>{data?.any_other_domain}</div>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
            {data?.education &&
              data?.education?.length > 0 &&
              userRole !== 20 && (
                <div className="row">
                  <div className="col-3">Educational Qualifications</div>
                  <div className="col-1">:</div>
                  <div className="col-8 overflow-auto">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        {
                          title: "No",
                          field: "area_management_id",
                          type: "dynId",
                        },
                        {
                          title: "Examination Passed",
                          field: "examination_passed",
                        },

                        {
                          title: "Board / University",
                          field: "board_of_university",
                        },
                        {
                          title: "Year of Pass",
                          field: "year_of_pass",
                        },
                        { title: "Marks / Grade", field: "mark_grade" },
                        {
                          title: "Certificate",
                          field: "edu_certificate",
                          type: "download",
                        },
                      ]}
                      data={data?.education ?? []}
                    />
                  </div>
                </div>
              )}
            {data?.education &&
              data?.education?.length > 0 &&
              userRole === 20 && (
                <div className="row">
                  <div className="col-3">Educational Qualifications</div>
                  <div className="col-1">:</div>
                  <div className="col-8 overflow-auto">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        {
                          title: " Board/University",
                          field: "university",
                        },
                        { title: "Location", field: "location" },
                        { title: "Year of Passing", field: "year" },
                        {
                          title: "Attainment Type",
                          field: "edu_qualification_type",
                        },
                        {
                          title: "Attainment",
                          field: "edu_qualification_text",
                        },
                        { title: "Equivalent Percentage", field: "percentage" },
                      ]}
                      data={data?.education ?? []}
                    />
                  </div>
                </div>
              )}
            {data?.employment && data?.employment?.length > 0 && (
              <>
                <div className="row">
                  <div className="col-3">Experience </div>
                  <div className="col-1">:</div>
                  <div className="col-8 overflow-auto">
                    <>
                      {data?.employment?.map((item, index) => (
                        <div className="white">
                          <div className="d-flex">
                            <div className="col-3">Employer </div>
                            <div className="col-1">:</div>
                            <div className="col-8">{item?.employer}</div>
                          </div>
                          <div className="d-flex">
                            <div className="col-3">Contact </div>
                            <div className="col-1">:</div>
                            <div className="col-8">{`${item?.contact}`}</div>
                          </div>
                          <div className="d-flex">
                            <div className="col-3">Email</div>
                            <div className="col-1">:</div>
                            <div className="col-8">{item?.email}</div>
                          </div>
                          <div className="d-flex">
                            <div className="col-3">Position</div>

                            <div className="col-1">:</div>
                            <div className="col-8">{item?.position}</div>
                          </div>
                          <div className="d-flex">
                            <div className="col-3">Currently Working</div>

                            <div className="col-1">:</div>
                            <div className="col-8">{item?.working ?? ""}</div>
                          </div>
                          <div className="d-flex">
                            <div className="col-3">Period</div>
                            <div className="col-1">:</div>
                            <div className="col-8">
                              {item?.from} - {item?.to ?? ""}
                            </div>
                          </div>
                          <div className="d-flex">
                            <div className="col-3">Reason for Leaving</div>
                            <div className="col-1">:</div>{" "}
                            <div className="col-8">{item?.reason ?? ""}</div>
                          </div>
                          <div className="d-flex">
                            <div className="col-3">Address</div>
                            <div className="col-1">:</div>
                            <div className="col-8">{item?.address}</div>
                          </div>
                          <div className="d-flex">
                            <div className="col-3">Certificate</div>
                            <div className="col-1">:</div>
                            <div className="col-8">
                              <div
                                className="text-warning"
                                style={{ cursor: "pointer" }}
                                onClick={(e) =>
                                  fullfileDownload(item?.exp_certificate)
                                }
                              >
                                Download Document
                              </div>
                            </div>
                          </div>
                          <hr />
                        </div>
                      ))}
                    </>
                  </div>
                </div>
              </>
            )}

            {data?.reference_name1 && (
              <>
                <div className="row">
                  <div className="col-3">Reference 1 </div>
                  <div className="col-1">:</div>
                  <div className="col-8 overflow-auto">
                    <>
                      <div className="white">
                        <div className="d-flex">
                          <div className="col-3">Name </div>
                          <div className="col-1">:</div>
                          <div className="col-8">{data.reference_name1}</div>
                        </div>
                        <div className="d-flex">
                          <div className="col-3">Designation </div>
                          <div className="col-1">:</div>
                          <div className="col-8">
                            {data.reference_designation1}
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="col-3">Address </div>
                          <div className="col-1">:</div>
                          <div className="col-8">{data.reference_address1}</div>
                        </div>
                        <div className="d-flex">
                          <div className="col-3">Contact </div>
                          <div className="col-1">:</div>
                          <div className="col-8">{data.reference_contact1}</div>
                        </div>
                        <div className="d-flex">
                          <div className="col-3">Email </div>
                          <div className="col-1">:</div>
                          <div className="col-8">{data.reference_email1}</div>
                        </div>

                        <hr />
                      </div>
                    </>
                  </div>
                </div>
              </>
            )}

            {data?.reference_name2 && (
              <>
                <div className="row">
                  <div className="col-3">Reference 2 </div>
                  <div className="col-1">:</div>
                  <div className="col-8 overflow-auto">
                    <>
                      <div className="white">
                        <div className="d-flex">
                          <div className="col-3">Name </div>
                          <div className="col-1">:</div>
                          <div className="col-8">{data.reference_name2}</div>
                        </div>
                        <div className="d-flex">
                          <div className="col-3">Designation </div>
                          <div className="col-1">:</div>
                          <div className="col-8">
                            {data.reference_designation2}
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="col-3">Address </div>
                          <div className="col-1">:</div>
                          <div className="col-8">{data.reference_address2}</div>
                        </div>
                        <div className="d-flex">
                          <div className="col-3">Contact </div>
                          <div className="col-1">:</div>
                          <div className="col-8">{data.reference_contact2}</div>
                        </div>
                        <div className="d-flex">
                          <div className="col-3">Email </div>
                          <div className="col-1">:</div>
                          <div className="col-8">{data.reference_email2}</div>
                        </div>

                        <hr />
                      </div>
                    </>
                  </div>
                </div>
              </>
            )}

            {data?.capital_investment && (userRole === 0 || userRole === 4) && (
              <div className="row">
                <div className="col-3">
                  Capital Investment Expected in Crores
                </div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.capital_investment ?? ""}</div>
              </div>
            )}
            {/* {data?.capital_investment && userRole === 5 && (
              <div className="row">
                <div className="col-3">Capital Investment so far Crores</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.capital_investment ?? ""}</div>
              </div>
            )} */}
            {data?.previous_fy_turnover && (
              <div className="row">
                <div className="col-3">Previous FY turnover Rs. in Crores</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.previous_fy_turnover ?? ""}</div>
              </div>
            )}
            {data?.fe_component && (
              <div className="row">
                <div className="col-3">FE Component </div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.fe_component ?? ""}</div>
              </div>
            )}
            {data?.travell_interest && (
              <div className="row">
                <div className="col-3">
                  Willingness to travel within India / abroad
                </div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.travell_interest == 0 ? "No" : "Yes"}
                </div>
              </div>
            )}
            {data?.desc_of_current_work && (
              <div className="row">
                <div className="col-3">Current work details</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {data?.desc_of_current_work ?? "--"}
                </div>
              </div>
            )}
            {data?.resume && (
              <div className="row">
                <div className="col-3">Download Resume</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  {/* {data?.desc_of_current_work ?? "--"} */}
                  <button
                    className="btn btn-approve btn-success"
                    onClick={(e) => handleDownloadExpCert(data?.resume)}
                  >
                    Download Resume
                  </button>
                </div>
              </div>
            )}

            {/* {data?.ex_man_power && (
              <div className="row">
                <div className="col-3"> Initial Direct Employment</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.ex_man_power ?? ""}</div>
              </div>
            )} */}
            {data?.certification && (
              <div className="row">
                <div className="col-3"> Certifications</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.certification ?? ""}</div>
              </div>
            )}
            {data?.achievements && (
              <div className="row">
                <div className="col-3"> Achievments</div>
                <div className="col-1">:</div>
                <div className="col-8">{data?.achievements ?? ""}</div>
              </div>
            )}
            {/* {data?.file_name && (
              <div className="row">
                <div className="col-3">Document Uploaded</div>
                <div className="col-1">:</div>
                <div className="col-8 ">{data?.file_name}</div>
              </div>
            )} */}
            {data?.file_name && userRole == 8 && (
              <div className="row">
                <div className="col-3">Institutional Activities</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  <button
                    onClick={() => {
                      fileDownload(data?.file_name);
                    }}
                  >
                    View
                  </button>
                </div>
              </div>
            )}
            {data?.cv_upload && (
              <div className="row">
                <div className="col-3">CV File</div>
                <div className="col-1">:</div>
                <div className="col-8">
                  <button
                    onClick={() => {
                      fileDownload(data?.cu_upload);
                    }}
                  >
                    View
                  </button>
                </div>
              </div>
            )}
            {data?.notes_institutions && (
              <div className="row">
                <div className="col-3">Institution Activities</div>
                <div className="col-1">:</div>
                <div className="col-8 ">{data?.notes_institutions}</div>
              </div>
            )}
          </div>
          {data?.area_management && data?.area_management?.length > 0 && (
            <div>
              <div className="dahContent-header-section2">Area Requirements</div>
            </div>
          )}

          <div className="dash-items-datas">
            {data?.area_type === "built_up_space" && (
              <div className="row">
                <div className="col-3" style={{ marginLeft: "6px" }}>Built-up space on Rent per Month</div>
                <div className="col-1">:</div>
                <div className="col-7 overflow-auto">
                  <CustomTable
                    className="areatable"
                    {...props}
                    columns={[
                      { title: "Preference No", field: "id", type: "dynId" },
                      { title: "Location", field: "location" },
                      { title: "Sub Location", field: "sub_location" },
                      {
                        title: "Category",
                        field: "area_type",
                        render: (rowData) =>
                          rowData.area_type === "built_up_space"
                            ? "Built-up Space"
                            : "Land",
                      },
                      {
                        title: "Built-up Space Category",
                        field: "built_space_type",
                      },
                      {
                        title: "Area Requirement (Requested area in sqft)",
                        field: "area_in_sqft",
                      },
                    ]}
                    data={data?.area_management ?? []}
                  />
                </div>
              </div>
            )}
            {data?.area_type === "equipped_facility" && (
              <div className="row">
                <div className="col-3" style={{ marginLeft: "6px" }}>Equipped Facility per Month </div>
                <div className="col-1">:</div>
                <div className="col-7 overflow-auto">
                  <CustomTable
                    className="areatable"
                    {...props}
                    columns={[
                      {
                        title: "No",
                        field: "area_management_id",
                        type: "dynId",
                      },
                      { title: "Location", field: "location" },
                      { title: "Area in sq.ft", field: "area_in_sqft" },
                    ]}
                    data={data?.area_management ?? []}
                  />
                </div>
              </div>
            )}
            {data?.area_type === "land_on" && (
              <div className="row">
                <div className="col-3" style={{ marginLeft: "6px" }}>Land on 30 years Lease </div>
                <div className="col-1">:</div>
                <div className="col-7 overflow-auto">
                  <CustomTable
                    className="areatable"
                    {...props}
                    columns={[
                      { title: "Preference No", field: "id", type: "dynId" },
                      { title: "Location", field: "location" },
                      { title: "Sub Location", field: "sub_location" },
                      {
                        title: "Category",
                        field: "area_type",
                        render: (rowData) =>
                          rowData.area_type === "built_up_space"
                            ? "Built-up Space"
                            : "Land On Lease",
                      },
                      {
                        title: "Land Requirement(in cents)",
                        field: "area_in_acres",
                      },
                      // { title: "Address", field: "land_address" },

                      { title: "Lease Years", field: "lease_year" },
                    ]}
                    data={data?.area_management ?? []}
                  />
                </div>
              </div>
            )}
            {data?.area_type === "joint_venture" && (
              <div className="row">
                <div className="col-3" style={{ marginLeft: "6px" }}>Joint Venture</div>
                <div className="col-1">:</div>
                <div className="col-7 venure">
                  {data?.area_management.map((item, i) => (
                    <div
                      key={i}
                      className={`row venture ${i !== data?.area_management.length - 1
                        ? "joint-view-border"
                        : ""
                        }`}
                    >
                      <div className="col-12 mb-1">
                        <b>{item.location}</b> {item.sub_location && <>- {item.sub_location}</>}
                      </div>
                      <div className="col-12 mb-1">
                        <label>
                          <b>Category&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                        </label>
                        {item.joint_venture_category === "built-up" ? "Built-up Space" : item.joint_venture_category === "land" ? "Land" : "--"}
                      </div>
                      {item.joint_venture_category === "built-up" && item.built_space_type && (
                        <div className="col-12 mb-1">
                          <label>
                            <b>Area Type&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                          </label>
                          {item.built_space_type}
                        </div>
                      )}
                      <div className="col-12 mb-1">
                        <label>
                          <b>
                            {item.joint_venture_category === "land" ? "Land Requirement" : "Area Requirement"}
                            &nbsp;:&nbsp;
                          </b>
                        </label>
                        {item.area_in_sqft} {item.joint_venture_category === "land" ? "Cents" : "Sq.ft"}
                      </div>
                      {item.joint_venture_category === "land" && item.lease_year && (
                        <div className="col-12 mb-1">
                          <label>
                            <b>Lease Years&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                          </label>
                          {item.lease_year}
                        </div>
                      )}
                      <div className="col-12 mb-1 text-justify">
                        <label>
                          <b>Investment Model</b>&nbsp;:&nbsp;
                        </label>
                        {item.investment_model}
                      </div>
                      <div className="col-12 mb-2 pb-1 text-justify">
                        <label>
                          <b>Management Plan</b>&nbsp;:&nbsp;
                        </label>
                        {item.management_plan}
                      </div>
                      {item.land_address && (
                        <div className="col-12 mb-2 pb-1 text-justify">
                          <label>
                            <b>Address</b>&nbsp;:&nbsp;
                          </label>
                          {item.land_address}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {data?.area_type === "own_land" && (
              <div className="row">
                <div className="col-3" style={{ marginLeft: "6px" }}>
                  Own Premises
                </div>
                <div className="col-1">:</div>
                <div className="col-7 overflow-auto">
                  <CustomTable
                    className="areatable"
                    {...props}
                    columns={[
                      { title: "Location", field: "location" },
                      { title: "Available Area", field: "area_in_sqft" },
                      // { title: "Land Address", field: "land_address" },
                      { title: "Survey Number", field: "survey_no" },
                      { title: "Block Number", field: "block_no" },
                      { title: "Village Name", field: "village_name" },
                      // { title: "Available Area", field: "area" },
                      // { title: "Available Area", field: "area" },
                      {
                        title: "Nature Of Holding",
                        field: "nature_of_holding",
                      },
                    ]}
                    data={data?.area_management ?? []}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="d-flex row justify-content-center">
          <div className="goto-my-profile col-2">
            <div
              className="dashuserprof"
              style={{
                whiteSpace: "nowrap",
                background: "#0a223d",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                padding: "4px 8px",
                cursor: "pointer",
                fontSize: 12,
              }}
              onClick={(e) => props.handleMenus("application")}
            >
              Back To Dashboard
            </div>
          </div>

          {/* {data?.status === 7 &&
          <div className="goto-my-profile col-2">
            <div
              className="dashusermyprof"
              // onClick={(e) => props.handleMenus("application")}
            >
              Edit Profile
            </div>
          </div>

        } */}
        </div>
      </div>

      {/* Company Users Section - Visible to user_type 0,4,5,21 but not to company sub-users */}
      {(props.userType === 0 || props.userType === 4 || props.userType === 5 || props.userType === 21) &&
        !props?.companyData?.is_company_user && !props?.data?.is_company_user && (<div className="row muli">
          <div className="col-12">
            <div className="dash-details-body">
              <div style={{
                border: "1px solid #e9ecef",
                borderRadius: 8,
                padding: 16,
                background: "#fff",
                marginBottom: 16
              }}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 12
                }}>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8
                  }}>
                    <CustomIcons iconName="users" iconClass="dash-application-icon" />
                    <div style={{ fontWeight: 600, fontSize: 16, gap: 0 }}>
                      Company Users Management
                    </div>
                  </div>
                  <button
                    className="dashuserprof"
                    style={{
                      background: "#0a223d",
                      color: "#fff",
                      border: "none",
                      borderRadius: 6,
                      padding: "6px 12px",
                      cursor: "pointer",
                      fontSize: 12,
                      display: "flex",
                      alignItems: "center",
                      gap: 6
                    }}
                    onClick={() => history.push("/directory-company-users")}
                  >
                    <CustomIcons iconName="view" iconClass="btn-icon" />
                    View Users
                  </button>
                </div>

                <div style={{
                  fontSize: 14,
                  color: "#6c757d",
                  lineHeight: 1.5
                }}>
                  View and manage company users, their roles, and access permissions within your organization's KSPACE portal.
                </div>

                {/* <div style={{
                  display: "flex",
                  gap: 12,
                  marginTop: 12,
                  flexWrap: "wrap"
                }}>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    fontSize: 12,
                    color: "#495057"
                  }}>
                    <CustomIcons iconName="user" iconClass="dash-feature-icon" />
                    User Management
                  </div>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    fontSize: 12,
                    color: "#495057"
                  }}>
                    <CustomIcons iconName="shield" iconClass="dash-feature-icon" />
                    Role Control
                  </div>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    fontSize: 12,
                    color: "#495057"
                  }}>
                    <CustomIcons iconName="settings" iconClass="dash-feature-icon" />
                    Access Permissions
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        )}
    </>
  );
};

export default DashProfileDetails;
